import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { CertificatorService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CertificatorCreateDto,
  CertificatorDto,
  CertificatorExcelDownloadDto,
  CertificatorUpdateDto,
} from '../proxy/planning/dtos/certificator';
import { CERTIFICATOR_CONFIG, CERTIFICATOR_FIELDS } from './certificator.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-certificator',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CertificatorService, ConfirmationService],
  templateUrl: './certificator.html',
  styleUrl: './certificator.scss',
})
export class Certificator extends BaseCrudComponent<
  CertificatorDto,
  CertificatorCreateDto,
  CertificatorUpdateDto,
  CertificatorExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(CertificatorService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Certificator', ids),
  };
  config = CERTIFICATOR_CONFIG;
  fields = CERTIFICATOR_FIELDS;

  protected prepareUpdateDto(data: any, selected: CertificatorDto): CertificatorUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Certificator';
  }
}
